import {
  Card,
  Container,
  SimpleGrid,
  Stack,
  Tabs,
  Text,
  Title,
} from "@mantine/core";
import { Breadcrumb } from "../../components/common/Breadcrumb";
import { LanguageDictionary } from "../admin/LanguageDictionary";
import { ProficiencyDictionary } from "../admin/ProficiencyDictionary";

export function OperationsLanguageDictionaries() {
  return (
    <Container size="xl" py="xl">
      <Stack gap="xl">
        <div>
          <Breadcrumb
            items={[
              { label: "Operations Panel", href: "/operations" },
              { label: "Dictionaries", href: "/operations/dictionaries" },
              { label: "Language Dictionaries", isActive: true },
            ]}
          />
          <Title order={1} size="h2" fw={700}>
            Language Dictionaries
          </Title>
          <Text c="dimmed" size="lg">
            Manage languages and proficiency levels in the system
          </Text>
        </div>

        <Tabs defaultValue="languages">
          <Tabs.List mb="md">
            <Tabs.Tab value="languages">Languages</Tabs.Tab>
            <Tabs.Tab value="proficiencies">Proficiency Levels</Tabs.Tab>
          </Tabs.List>

          <Tabs.Panel value="languages">
            <LanguageDictionary />
          </Tabs.Panel>

          <Tabs.Panel value="proficiencies">
            <ProficiencyDictionary />
          </Tabs.Panel>
        </Tabs>

        <Card withBorder p="lg">
          <Stack gap="md">
            <Title order={3} size="h4">
              About Language Dictionaries
            </Title>
            <Text size="sm" c="dimmed">
              These dictionaries allow you to standardize language-related data
              across the system. You can manage languages and proficiency levels
              to ensure consistency in CVs and profiles.
            </Text>

            <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="md">
              <Card withBorder p="md" shadow="sm">
                <Title order={4} size="h5">
                  Languages
                </Title>
                <Text size="sm" c="dimmed">
                  Manage languages with both English and native names
                </Text>
              </Card>
              <Card withBorder p="md" shadow="sm">
                <Title order={4} size="h5">
                  Proficiency Levels
                </Title>
                <Text size="sm" c="dimmed">
                  Define language proficiency levels like A1, B2, C1, Fluent,
                  etc.
                </Text>
              </Card>
            </SimpleGrid>
          </Stack>
        </Card>
      </Stack>
    </Container>
  );
}
